import { BookOpen, Users, Wallet, Award, Video, Shield } from "lucide-react";

const features = [
  {
    icon: Video,
    title: "Premium Video Courses",
    description: "High-quality video lessons from industry experts, covering in-demand skills.",
  },
  {
    icon: Award,
    title: "Earn Certificates",
    description: "Get verified certificates upon completion to boost your career prospects.",
  },
  {
    icon: Users,
    title: "Referral Program",
    description: "Earn up to ₦4,000 for every friend you refer who joins the platform.",
  },
  {
    icon: Wallet,
    title: "Easy Withdrawals",
    description: "Withdraw your earnings directly to your bank account or mobile money.",
  },
  {
    icon: BookOpen,
    title: "Lifetime Access",
    description: "Pay once and get unlimited access to all courses, forever.",
  },
  {
    icon: Shield,
    title: "Secure Payments",
    description: "Your payments are protected with bank-grade encryption technology.",
  },
];

const Features = () => {
  return (
    <section className="py-24 bg-gradient-surface">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-semibold text-primary uppercase tracking-wider">Why Choose Us</span>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground mt-4 mb-6">
            Everything You Need to{" "}
            <span className="text-gradient-hero">Succeed</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Join thousands of Nigerians who are advancing their careers with our comprehensive learning platform.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group p-8 rounded-2xl bg-card shadow-card hover:shadow-elevated transition-all duration-300 hover:-translate-y-1 animate-fade-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-primary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
